module.exports = __webpack_public_path__ + "img/editor.8f7afd61.gif";